import React, { useState, useEffect, useRef } from 'react'
import { CreateUrl, CallGetAPI, CallPostAPI, CallPutAPI, CallDeleteAPI } from 'Utils/ApiHelper.js';
import { DataGrid, Column, GroupPanel, Grouping, FilterRow, Pager, Paging, StateStoring, Format, Export, HeaderFilter } from 'devextreme-react/data-grid';
import { APILoggerDetail, buildAPILoggerDetail } from 'models/APILoggerDetail';

import { Redirect } from "react-router-dom";
import IconButton from '@mui/material/IconButton';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { Menu, Chip, useTheme } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import Modal from 'react-bootstrap/Modal'
import Button from '@mui/material/Button';
import UploadDialog from '../../components/ImageUpload/UploadDialog';
import SiteModal from './NewSiteModal2024'
import Tabs from 'devextreme-react/tabs'
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import { withStyles, createStyles } from '@mui/styles';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { NotificationManager } from 'react-notifications';
import Tooltip from '@mui/material/Tooltip';
import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded';
import SettingsBackupRestoreRoundedIcon from '@mui/icons-material/SettingsBackupRestoreRounded';
import GoogleMapsMultiPolygon from '../../components/Map/NewGoogleMaps2024MultiPolygon';
import { isLCLLogger } from 'variables/chariotProductIds';

import { FormattedMessage, useIntl } from 'react-intl';
import deMessages from "devextreme/localization/messages/de.json";
import frMessages from "devextreme/localization/messages/fr.json";
import esMessages from "devextreme/localization/messages/es.json";
import ptMessages from "devextreme/localization/messages/pt.json";
import { locale, loadMessages } from "devextreme/localization";
import Loader from '../../Utils/Loader/NewLoader2025'
import { Site, deleteRow, handleTextFieldChange, handleLoggersToBeUnassigned, Boundary, Company, GPS, defaultCenter, reloadData, handleSiteChange, Coordinates, BoundaryStyling, Name } from '../../components/Site Functions/LoadSiteData'
interface Props {
    classes: {
        cardTitleWhite: string;
        formControl: string;
        cardCategoryWhite: string;
    };
    history: {
        goBack: () => void;
    };
    location: {
        state: {
            serial: number | null
        };

    };
}

interface RedirectProps {
    siteName: string;
    siteId: number | null;
    serial: string;
    deviceId: number | null;
}

interface Offset {
    x: number
    y: number
}





const styles: Record<string, any> = {
    formControl: {
        minWidth: 120,
    },
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0"
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF"
        }
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    }
};

const style = createStyles(styles);


const Sites: React.FC<Props> = ({ classes, history, location }) => {
    locale(sessionStorage.getItem("language"));
    loadMessages(frMessages);
    loadMessages(deMessages);
    loadMessages(esMessages);
    loadMessages(ptMessages);



    const intl = useIntl()






    const [authorized, setAuthorized] = useState<boolean>(true)
    const [activeSites, setActiveSites] = useState<Array<Site>>([])
    const [inactiveSites, setInactiveSites] = useState<Array<Site>>([])
    const [redirect, setRedirect] = useState<boolean>(false)
    const [redirectPath, setRedirectPath] = useState<string>("")
    const [redirectProps, setRedirectProps] = useState<RedirectProps>({
        siteName: "",
        siteId: null,
        serial: "",
        deviceId: null
    })
    const [anchorEl, setAnchorEl] = useState<HTMLElement>()
    const [tempSite, setTempSite] = useState<Site>({
        siteName: "",
        siteNameUserFriendly: "",
        loggers: [],
        latitude: 0,
        longitude: 0,
        createdDate: undefined,
        fkCompanyId: parseInt(sessionStorage.getItem('companyId') || '0'),
        defaultSite: false,
        fkEASiteId: null,
    })
    const [imageDialog, setImageDialog] = useState(false)
    const [modal, setModal] = useState(false)
    const [modalTitle, setModalTitle] = useState<string>("")
    const [selectedTab, setSelectedTab] = useState<number>(0)
    const [loggersToBeAssigned, setLoggersToBeAssigned] = useState<Array<APILoggerDetail>>([])
    const [editSite, setEditSite] = useState<boolean>(false)
    const [deleteModal, setDeleteModal] = useState<boolean>(false)
    const [loggersToBeUnassigned, setLoggersToBeUnassigned] = useState<Array<APILoggerDetail>>([])
    const [markers, setMarkers] = useState<Array<GPS>>([])
    const [boundaries, setBoundaries] = useState<Array<Boundary>>([])
    const activeGridRef = useRef(null)
    const inactiveGridRef = useRef(null)
    const mapRef = useRef(null)
    const anchorElRef = useRef(null);
    const [showTooltip, setShowTooltip] = useState<boolean>(false)
    const [hoveredBoundary, setHoveredBoundary] = useState<Site>({})
    const [tooltipHovered, setTooltipHovered] = useState<boolean>(false)
    const [mouseOverBoundary, setMouseOverBoundary] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false)
    const [companies, setCompanies] = useState<Array<Company>>([])


    useEffect(() => {
        reloadData(
            setLoading,
            setBoundaries,
            companies,
            setCompanies,
            setMarkers,
            setActiveSites,
            setInactiveSites,
            setLoggersToBeAssigned,
            setAuthorized
        )
    }, [])

    const handleDeviceRender = ({ data }) => {
        return data.loggers.length
        /*if (data.loggers.length === 1) {
            return <Chip label={data.loggers[0].serial} color="primary"/>
        } else {
            return <div>
                {data.loggers.map(logger => <Chip key={logger.serial} label={logger.serial} color="primary" style={{marginRight: "10px"} } />)}
            </div>
        
        }*/
    }

    const createSuccessNotification = (): void => {
        NotificationManager.success(intl.formatMessage({ id: 'Saved Changes' }), intl.formatMessage({ id: 'Success' }))

    };

    const createErrorNotification = (): void => {
        NotificationManager.error(intl.formatMessage({ id: 'Error Saving Changes' }), "", 5000, () => {
            alert(window.location.hostname.includes('zonelog.net') ? intl.formatMessage({ id: 'contact ZONELOG Support' }) : intl.formatMessage({ id: 'contact Ashridge Support' }));
        });
    };


    const deviceDetailsClick = (serial: string, id: number): void => {
        if (id < 50000) {

            setRedirect(true)
            setRedirectPath('/portal/DeviceOverview')
            setRedirectProps({
                serial: serial,
                deviceId: id,
                siteId: null,
                siteName: ''
            })               
        }
        else {
            setRedirect(true)
            setRedirectPath('/portal/LCLDeviceDetail')
            setRedirectProps({
                serial: serial,
                deviceId: id,
                siteId: null,
                siteName: ''
            })             
        }
    }

    const moreRender = (site: any): React.ReactNode => {
        return (
        <div style={{display: "flex", justifyContent: "center"} }>
            <IconButton size="small" onClick={(e): void => { handleClick(e, site) }}><MoreHorizIcon /></IconButton>
        </div>)
    }

    const handleClick = (event: any, site: Site): void => {
            setAnchorEl(event.currentTarget)
            setTempSite(site)
    }

    const handleClose = () => {
        setAnchorEl(null);
        setTempSite({
            siteName: "",
            siteNameUserFriendly: "",
            loggers: [],
            latitude: 0,
            longitude: 0,
            createdDate: undefined,
            fkCompanyId: parseInt(sessionStorage.getItem('companyId') || '0'),
            defaultSite: false,
            fkEASiteId: null,
        })
    }

    const toggleImageModal = ():void => {      
        setImageDialog(!imageDialog)
        setAnchorEl(null)
    }

    const toggleEditModal = (): void => {
        if (modal) {
            setTempSite({
                siteName: "",
                siteNameUserFriendly: "",
                loggers: [],
                latitude: 0,
                longitude: 0,
                createdDate: undefined,
                fkCompanyId: parseInt(sessionStorage.getItem('companyId') || '0'),
                defaultSite: false,
                fkEASiteId: null,
            })
            setEditSite(false)
        } else {
            setEditSite(true)
        }
        setModal(!modal)
        setModalTitle(intl.formatMessage({ id: 'Edit Site -' }))
        setAnchorEl(null)
        

    }

    const toggleNewModal = ():void => {
        setTempSite({
            siteName: "",
            siteNameUserFriendly: "",
            loggers: [],
            latitude: 0,
            longitude: 0,
            createdDate: undefined,
            fkCompanyId: parseInt(sessionStorage.getItem('companyId') || '0'),
            defaultSite: false,
            fkEASiteId: null,
        })
        openNewSiteModal()    
        
    }        

    const openNewSiteModal = ():void => {
        setModal(!modal)
        setModalTitle(intl.formatMessage({ id: 'New Site' }))
        setAnchorEl(null)
        setEditSite(false)
    }


    const toggleDeleteModal = () => {
        setModalTitle(intl.formatMessage({ id: 'Delete Site' }))
        setDeleteModal(!deleteModal)
        setAnchorEl(null)
    }

    const toggleSiteDetail = () => {
            setRedirect(true)
            setRedirectPath('/portal/SiteDetail')
            setRedirectProps({
                siteName: tempSite.siteNameUserFriendly || tempSite.siteName,
                siteId: tempSite.siteId,
                serial: '',
                deviceId: null
            })
    }


    const siteAlarmsClick = (): void => {

                setRedirect(true)
                setRedirectPath('/portal/SiteAlarmConfigs')
                setRedirectProps({
                    siteName: tempSite.siteNameUserFriendly || tempSite.siteName,
                    siteId: tempSite.siteId,
                    serial: '',
                    deviceId: null
                })

    }



    const clearState = ():void => {
        localStorage.removeItem('siteListGridActive')
        localStorage.removeItem('siteListGridInActive')
        activeGridRef.current = null
        inactiveGridRef.current = null
    }

    const onMapLoad = (map): void => {

        mapRef.current = map;
        map.setMapTypeId("hybrid")
        fitBoundsToMarkers();
    };

    const fitBoundsToMarkers = () => {
        if (mapRef.current && markers.length > 0) {
            const bounds = new window.google.maps.LatLngBounds();
            markers.forEach((marker) => {
                bounds.extend(marker.position);
            });
            
            if (boundaries.length > 0 ) {

                boundaries.forEach(boundary => {
                    if (Array.isArray(boundary.path)) {
                        boundary.path.forEach((corner) => {
                            bounds.extend(corner)
                        })
                    }
                })
            }
            mapRef.current.fitBounds(bounds);
        }
    };


    const handlePolygonClick = (siteId: number): void => {
        
        let boundaryClicked = activeSites.filter(site => site.siteId === siteId)[0]
        if (!boundaryClicked) {
            boundaryClicked = inactiveSites.filter(site => site.siteId === siteId)[0]
        }
        if (boundaryClicked) {
            setRedirect(true)
            setRedirectPath('/portal/SiteDetail')
            setRedirectProps({
                siteName: boundaryClicked.siteNameUserFriendly || boundaryClicked.siteName,
                siteId: boundaryClicked.siteId,
                serial: '',
                deviceId: null
            })  
        } else alert(intl.formatMessage({ id: 'Error finding site details' }))
    }

    const handleMouseOverPolygon = (siteId: number, e: React.MouseEvent): void => {
        setMouseOverBoundary(true)
        

        const boundaryHovered = activeSites.filter(site => site.siteId === siteId)[0]
        setShowTooltip(true)
        setHoveredBoundary(boundaryHovered)
    }


    const handleMouseLeavePolygon = (): void => {
        setMouseOverBoundary(false)
        setTimeout(() => {
            if (!tooltipHovered) {
                setShowTooltip(false)
            }
        }, 2000)
    }


    const handleMouseOverTooltip = (e): void => {
        e.stopPropagation()
        setTooltipHovered(true)
    }
    const handleMouseLeaveTooltip = (): void => {
        setTooltipHovered(false)
        if (!mouseOverBoundary) { 
            setShowTooltip(false)
        }
    }

    const handleEditClick = (e, siteId: number): void => {
        e.stopPropagation()
        const selectedSite = activeSites.filter(site => site.siteId === siteId)[0]
        setTempSite(selectedSite)
        toggleEditModal()
    }

    const handleMarkerClick = (marker) => {
        const relatedSite = activeSites.filter(site => site.loggers.map(logger => logger.serial).includes(marker.serial))[0]
        setRedirect(true)
        setRedirectPath('/portal/SiteDetail')
        setRedirectProps({
            siteName: relatedSite.siteNameUserFriendly || relatedSite.siteName,
            siteId: relatedSite.siteId,
            serial: '',
            deviceId: null
        })  
    }    

    const handleChipClick = (serial: number, loggerId: number):void => {

        const clickedChip = activeSites
            .find(site => site.loggers.some(logger => logger.serial === serial))
            ?.loggers.find(logger => logger.serial === serial);
        setRedirect(true)
        setRedirectPath(!isLCLLogger(clickedChip.model) ? '/portal/DeviceDetail' : '/portal/LCLDeviceDetail')
        setRedirectProps({
            serial: serial,
            mapKey: 'test'
        })
    }

    const renderSiteName = (data) => {
        const theme = useTheme()

        return (<Chip
            label={data.data.siteNameUserFriendly}
            onClick={(): void => handlePolygonClick(data.data.siteId)}
            sx={{ backgroundColor: theme.palette.grey.main, color: theme.palette.grey.contrastText }}
        />)
        
    }





    const tabNames = [
        {
            id: 0,
            text: intl.formatMessage({ id: "Sites With Loggers" }),
            icon: "fa fa-mobile"

        },
        {
            id: 1,
            text: intl.formatMessage({ id: "Sites Without Loggers" }),
            icon: "fa fa-ban"
        }
 
    ]
    return (
        authorized ? (
            !redirect ? 
                <div>
                    {loading &&
                        <div style={{
                            position: 'absolute', left: 'Calc(50% - 100px)', top: 'Calc(50% - 100px)',
                            transform: 'translate(-50%, -50%)',
                            zIndex: 13000
                        }}>
                            <Loader />
                        </div>
                    }
                    {!loading && <div>
                        <Modal
                            show={deleteModal}
                            onHide={(): void => toggleDeleteModal()}
                            dialogClassName="modal-50w"
                            aria-labelledby="example-custom-modal-styling-title"
                            centered
                        >
                            <Modal.Header closeButton>
                                <Modal.Title id="example-custom-modal-styling-title">
                                    {modalTitle}
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body className="show-grid">
                                <h4>{`${intl.formatMessage({ id: "Delete Site" })} ${tempSite.siteNameUserFriendly || tempSite.siteName} ${intl.formatMessage({ id: "AND ALL associated Readings?" })}`}</h4>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button
                                    color="primary"
                                    variant="contained"
                                    style={{ marginRight: "10px" }}
                                    onClick={(): void => {
                                        deleteRow(
                                            tempSite,
                                            intl,
                                            setLoading,
                                            setBoundaries,
                                            companies,
                                            setCompanies,
                                            setMarkers,
                                            setActiveSites,
                                            setInactiveSites,
                                            setLoggersToBeAssigned,
                                            setAuthorized,
                                            toggleDeleteModal
                                        )
                                    }}>
                                    <FormattedMessage id="Continue" />
                                </Button>
                                <Button color="secondary" variant="contained" onClick={(): void => toggleDeleteModal()}><FormattedMessage id="Cancel" /></Button>
                            </Modal.Footer>
                        </Modal>

                        {companies.length > 0 && <SiteModal
                            open={modal}
                            modalTitle={`${modalTitle} ${tempSite?.siteNameUserFriendly ? tempSite?.siteNameUserFriendly : ""}`}
                            onCancel={toggleEditModal}
                            site={tempSite}
                            handleTextFieldChange={(name: string, value: string): void => {
                                handleTextFieldChange(
                                    name,
                                    value,
                                    tempSite,
                                    setTempSite
                                )
                            }}
                            unAssignedLoggers={loggersToBeAssigned}
                            selectedLogger={location.state?.serial ? location.state.serial : null}
                            editSite={editSite}
                            handleLoggersToBeUnassigned={(logger):void => {
                                handleLoggersToBeUnassigned(
                                    logger,
                                    loggersToBeUnassigned,
                                    tempSite,
                                    setTempSite,
                                    setLoggersToBeUnassigned
                                )
                            }
                            }
                            onSubmit={(selected: APILoggerDetail[], assignDate: Date, polygonPath: Coordinates[], boundaryStyling: BoundaryStyling, hasBoundary: boolean, tempName: Name, companyId: number): void => handleSiteChange(
                                selected,
                                assignDate,
                                polygonPath,
                                boundaryStyling,
                                hasBoundary,
                                tempName,
                                companyId,
                                editSite,
                                tempSite,
                                intl,
                                setLoading,
                                setBoundaries,
                                companies,
                                setCompanies,
                                setMarkers,
                                setActiveSites,
                                setInactiveSites,
                                setLoggersToBeAssigned,
                                setLoggersToBeUnassigned,
                                setAuthorized,
                                loggersToBeUnassigned,
                                setSelectedTab
                            )}
                            companies={companies}
                        />}

                        <UploadDialog
                            show={imageDialog}
                            title={intl.formatMessage({ id: "Add images to site" })}
                            siteId={tempSite ? tempSite.siteId : 0}
                            loggerId={0}
                            onSubmit={toggleImageModal}
                            onCancel={toggleImageModal}
                        />
                        <GridContainer >
                            <GridItem xs={12} sm={12} md={12}>
                                <Card>
                                    <CardHeader color="primary" className="view view-cascade  d-flex justify-content-between align-items-center py-2 mx-4 mb-3">

                                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                                            <IconButton
                                                style={{ display: 'inline' }}
                                                onClick={(): void => history.goBack()}
                                                size="large"><ArrowBackIcon style={{ fill: "white" }} />
                                            </IconButton>
                                            <h4 style={{ display: 'inline', paddingTop: 12 }} className={classes.cardTitleWhite}><FormattedMessage id='Sites' /></h4>
                                        </div>
                                        <div>
                                            <div style={{ display: 'inline' }}>
                                                <Tooltip title={intl.formatMessage({ id: "clear sort/filter" })}>
                                                    <IconButton
                                                        edge="start"
                                                        color="inherit"
                                                        onClick={(): void => clearState()}
                                                        aria-label="clear sort/filter"
                                                    >
                                                        <SettingsBackupRestoreRoundedIcon />
                                                    </IconButton>
                                                </Tooltip>
                                                <Tooltip title={intl.formatMessage({ id: "refresh data" })} >
                                                    <IconButton
                                                        edge="start"
                                                        color="inherit"
                                                        onClick={(): void => reloadData(
                                                            setLoading,
                                                            setBoundaries,
                                                            companies,
                                                            setCompanies,
                                                            setMarkers,
                                                            setActiveSites,
                                                            setInactiveSites,
                                                            setLoggersToBeAssigned,
                                                            setAuthorized
                                                        )}
                                                        aria-label="refresh"
                                                    >
                                                        <RefreshRoundedIcon />
                                                    </IconButton>
                                                </Tooltip>
                                            </div>
                                            {sessionStorage.getItem('canConfig') === "true" && <Button variant="contained" color="primary" style={{ marginRight: "10px" }} onClick={toggleNewModal}><FormattedMessage id="Add New Site" /></Button>}
                                        </div>
                                    </CardHeader>
                                    <CardBody>
                                        <div style={{ display: "flex" }}>
                                            <div style={{ width: "60%", marginRight: "10px" }}>
                                                <Tabs
                                                    onItemClick={(e): void => setSelectedTab(e.itemIndex)}
                                                    dataSource={tabNames}
                                                    defaultSelectedIndex={0}
                                                    style={{ fontSize: "18px" }}
                                                    selectionMode={'single'}
                                                    selectedIndex={selectedTab}


                                                />
                                                {selectedTab === 0 &&
                                                    <div style={{ border: "1px solid #dddddd", padding: "10px" }} >
                                                        <div style={{ border: "1px solid #dddddd" }}>
                                                            <DataGrid
                                                                dataSource={activeSites}
                                                                allowColumnResizing={true}
                                                                allowColumnReordering={true}
                                                                ref={activeGridRef}
                                                            >
                                                                <GroupPanel visible={true} />
                                                                <FilterRow visible={true} />
                                                                <StateStoring enabled={true} type="localStorage" storageKey="siteListGridActive" />
                                                                <Column dataField="isParent" caption={intl.formatMessage({ id: "Parent Company" })} groupIndex={0} defaultSortOrder={'desc'} />
                                                                <Column dataField="companyName" groupIndex={1} caption={intl.formatMessage({ id: "Company" })} />
                                                                <Column dataField="siteId" dataType="number" visible={false} />
                                                                <Column dataField="siteNameUserFriendly" dataType="string" caption={intl.formatMessage({ id: "Site Name" })} cellRender={renderSiteName} />
                                                                <Column dataField="siteName" dataType="string" caption={intl.formatMessage({ id: "Site Ref" })} />
                                                                <Column dataField="alarmsEnabled" dataType="number" caption={intl.formatMessage({ id: "Alarms" })} />
                                                                <Column dataField="loggers" caption={intl.formatMessage({ id: "Devices" })} cellRender={handleDeviceRender} />
                                                                <Column fixed={true} fixedPosition='right' type="edit" cellRender={(data): React.ReactNode => moreRender(data.data)} key='more' caption={intl.formatMessage({ id: "Action" })} width={75} />
                                                                <Pager allowedPageSizes={[5, 10, 20, 50]} showPageSizeSelector={true} />
                                                                <Paging defaultPageSize={10} />
                                                            </DataGrid>
                                                        </div>
                                                    </div>
                                                }
                                                {selectedTab === 1 &&
                                                    <div style={{ border: "1px solid #dddddd", padding: "10px" }} >
                                                        <div style={{ border: "1px solid #dddddd" }}>
                                                            <DataGrid
                                                                dataSource={inactiveSites}
                                                                ref={inactiveGridRef}
                                                            >
                                                                <GroupPanel visible={true} />
                                                                <FilterRow visible={true} />
                                                                <StateStoring enabled={true} type="localStorage" storageKey="siteListGridInActive" />
                                                                <Column dataField="isParent" caption={intl.formatMessage({ id: "Parent Company" })} groupIndex={0} defaultSortOrder={'desc'} />
                                                                <Column dataField="companyName" groupIndex={1} caption={intl.formatMessage({ id: "Company" })} />
                                                                <Column dataField="siteId" dataType="number" visible={false} />
                                                                <Column dataField="siteNameUserFriendly" dataType="string" caption={intl.formatMessage({ id: "Site Name" })} />
                                                                <Column dataField="siteName" dataType="string" caption={intl.formatMessage({ id: "Site Ref" })} />
                                                                <Column dataField="alarmsEnabled" dataType="number" caption={intl.formatMessage({ id: "Alarms" })} />
                                                                <Column fixed={true} fixedPosition='right' type="edit" cellRender={(data): React.ReactNode => moreRender(data.data)} key='more' caption={intl.formatMessage({ id: "Action" })} width={75} />
                                                                <Pager allowedPageSizes={[5, 10, 20, 50]} showPageSizeSelector={true} />
                                                                <Paging defaultPageSize={10} />
                                                            </DataGrid>
                                                        </div>
                                                    </div>
                                                }
                                            </div>

                                            <div style={{ width: "40%", marginleft: "10px" }}>
                                                {markers.length > 0 &&
                                                    <GoogleMapsMultiPolygon
                                                        markers={markers}
                                                        onMapLoad={onMapLoad}
                                                        boundaries={boundaries}
                                                        onPolygonClick={handlePolygonClick}
                                                        onMouseOverPolygon={showTooltip ? null : handleMouseOverPolygon}
                                                        onMouseLeavePolygon={handleMouseLeavePolygon}
                                                        showTooltip={showTooltip}
                                                        hoveredBoundary={hoveredBoundary}
                                                        onMouseOverTooltip={handleMouseOverTooltip}
                                                        onMouseLeaveTooltip={handleMouseLeaveTooltip}
                                                        onEditClick={handleEditClick}
                                                        handleMarkerClick={handleMarkerClick}
                                                        handleChipClick={handleChipClick}
                                                    />}
                                            </div>
                                        </div>
                                    </CardBody>
                                </Card>
                            </GridItem>
                        </GridContainer>

                        {anchorEl && <Menu
                            id="simple-menu"
                            anchorEl={anchorEl}
                            keepMounted
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                            transformOrigin={{ vertical: 'top', horizontal: 'center' }}
                            open={Boolean(anchorEl)}
                            onClose={handleClose}
                            disableScrollLock={true}
                        >
                            {sessionStorage.getItem('canConfig') === "true" && <MenuItem onClick={toggleEditModal}><FormattedMessage id="Edit" /></MenuItem>}
                            <MenuItem onClick={toggleSiteDetail}><FormattedMessage id="Details" /></MenuItem>
                            {!window.location.hostname.includes('zonelog.net') && <MenuItem onClick={(): void => { siteAlarmsClick() }}><FormattedMessage id="Alarm Configs" /></MenuItem>}
                            <MenuItem onClick={toggleImageModal}><FormattedMessage id="Upload Picture" /></MenuItem>
                            {sessionStorage.getItem('canConfig') === "true" && <MenuItem onClick={(): void => { toggleDeleteModal() }}><FormattedMessage id="Delete" /></MenuItem>}
                        </Menu>}
                    </div>}
                </div>
                :
            <Redirect push to={{
                pathname: redirectPath,
                state: redirectProps
            }} />
            ) :
        <Redirect to={'/Login'} />
    )
}
export default withStyles(style)(Sites);